import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/affstyle.css";
import HeaderBackground from "../common/SubpagesBGimage";
import SideNavigation from "../components/Menu-sidenavbar/SideNavigation ";
import Footer from "../components/Layout/Footer";
import Header from "../components/Layout/Header";
import { ApprovalAction } from "../Store/ApprovalAffiliations/action";

// PDF Viewer
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

function ApprovalAffiliations() {
  const dispatch = useDispatch();
  const { Approvals, loading } = useSelector((state) => state.approval);

  const [activeSection, setActiveSection] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);

  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  document.title = "Approval & Affiliations";

  /* Fetch API */
  useEffect(() => {
    dispatch({ type: ApprovalAction.GET_APPROVALS });
  }, [dispatch]);

  /* Default Section */
  useEffect(() => {
    if (!loading && Approvals && Object.keys(Approvals).length > 0 && !activeSection) {
      const firstSection = Object.keys(Approvals)[0];
      setActiveSection(firstSection);

      const years = Object.keys(Approvals[firstSection]?.pdfs || {});
      setSelectedYear(years.length > 0 ? years[0] : "");
    }
  }, [loading, Approvals, activeSection]);

  if (!Approvals || Object.keys(Approvals).length === 0) return <p></p>;

  const menuItems = Object.keys(Approvals);
  const pdfs = activeSection ? Approvals[activeSection]?.pdfs || {} : {};
  const selectedPdf = selectedYear ? pdfs[selectedYear] : null;
  const showYearTabs = Object.keys(pdfs).length > 1;

  return (
    <div>
      <HeaderBackground
        menuName="About Us"
        subMenuName="Statutory Committee"
        thirdLevelName="Approval Affiliations"
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
      />

      <Header />

      {/* --- Main Wrapper Section (Matches Admissions) --- */}
      <section className="services-tab section-padding mb-80">
        <div className="container">
          {/* Page Title */}
          <div className="cal-action pb-10 mb-40">
            <h1 className="fw-300 core-fac-heading-res heading-submenu-res overall-submenu-heading">
              Approval & Affiliations
            </h1>
          </div>

          <div className="row lg-marg" id="tabs">
            
            {/* -------- LEFT MENU (Desktop) -------- */}
            <div className="col-lg-4 d-none d-lg-block">
              <div className="serv-tab-link tab-links full-width pt-40">
                <div className="row justify-content-end admission-tabs">
                  <div className="col-lg-12">
                    <ul className="rest">
                      {menuItems.map((item) => (
                        <li
                          key={item}
                          className={`item-link mb-15 go-moreee-tabs go-more-psg-iap go-more-psg-iap-line1 ${
                            activeSection === item ? "current" : ""
                          }`}
                          onClick={() => {
                            setActiveSection(item);
                            const years = Object.keys(Approvals[item]?.pdfs || {});
                            setSelectedYear(years.length > 0 ? years[0] : "");
                          }}
                        >
                          <div className="u-line linee">
                            <span className="icon ti-arrow-circle-right"></span>
                            <span className="text fz-20 psg-margin">{item}</span>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* -------- RIGHT CONTENT -------- */}
            <div className="col-lg-8 col-12">
              <div className="aff-rightcontent card border-0 shadow-sm">
                <div className="card-body">

                  {loading ? (
                    <div className="text-center my-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <>
                      {/* Title */}
                      <h5 className="fw-bold mb-3 afftitle">
                        {Approvals[activeSection]?.title || ""}
                      </h5>

                      {/* Year Tabs */}
                      {showYearTabs && (
                        <ul className="nav nav-tabs year-tabs mb-3">
                          {Object.keys(pdfs).map((year) => (
                            <li
                              key={year}
                              className={`nav-item year-item ${selectedYear === year ? "active" : ""}`}
                              onClick={() => setSelectedYear(year)}
                            >
                              {year}
                            </li>
                          ))}
                        </ul>
                      )}

                      {/* SubTitle */}
                      <h6 className="fw-bold mb-3 affsub">
                        {Approvals[activeSection]?.subTitle} {selectedYear}
                      </h6>

                      {/* PDF Viewer */}
                      {selectedPdf ? (
                        selectedPdf.pdf_url.startsWith("https://psg.mindmadetech.in") ? (
                          <div style={{ height: "600px" }}>
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                              <Viewer
                                fileUrl={selectedPdf.pdf_url}
                                plugins={[defaultLayoutPluginInstance]}
                              />
                            </Worker>
                          </div>
                        ) : (
                          <embed
                            src={selectedPdf.pdf_embed}
                            type="application/pdf"
                            width="100%"
                            height="600px"
                          />
                        )
                      ) : (
                        <p>No PDF available for this year.</p>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Side Navigation */}
      <SideNavigation
        key="About Us"
        isMenuOpen={isMenuOpen}
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        defaultOpenSubMenu="About Us"
      />

      <Footer />
    </div>
  );
}

export default ApprovalAffiliations;
